import { render, staticRenderFns } from "./layout-business-toolbar.vue?vue&type=template&id=47c63add&"
import script from "./layout-business-toolbar.vue?vue&type=script&lang=js&"
export * from "./layout-business-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports